import axios from 'axios';
import { Url } from '../url';

export type FbUserData = {
    fbId?: string | null;
    fbp?: string | null;
    firstName?: string | null;
    lastName?: string | null;
};

export type MarketingData = {
    ref: string;
    partner?: string | null;
    campaign?: string | null;
    clickId?: string | null;
    referrer?: string | null;
    isSuitableForSave: boolean;
    authOption?: string | null;
    fbData?: FbUserData | null;
};

export type RetentionData = {
    fdretention: number;
    ret1: boolean;
    ret7: boolean;
};

export async function getMarketingData(): Promise<MarketingData> {
    return axios.get(Url.getNoLangUrl('marketing/getData/'));
}

export async function getRetentionData(
    isSuidSimulate: number,
    registerTs: number,
    registration: number
): Promise<RetentionData> {
    return axios.get(Url.getNoLangUrl('marketing/getRetentionData/'), {
        params: {
            isSuidSimulate: isSuidSimulate,
            registerTs:registerTs,
            registration: registration
        }
    });
}
